module.exports = __webpack_public_path__ + "static/media/font_medium.c54e0d68.woff2";